import { handleLink } from './thrive-design-link-wrapping';

function handleCTATiles() {
    $('.cta-tile .HtmlContent').each(function() {
        handleLink(this);
    });
}

$(function () {
    handleCTATiles();
});